/**
 * @generated SignedSource<<8a5d43c2e8765c9dd22fc2bd9d297f0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VerifyResetKeyInput = {
  key: string;
  clientMutationId?: string | null;
};
export type verifyResetKeyMutation$variables = {
  input: VerifyResetKeyInput;
};
export type verifyResetKeyMutation$data = {
  readonly verifyResetKey: {
    readonly isKeyValid: boolean | null;
  } | null;
};
export type verifyResetKeyMutation = {
  variables: verifyResetKeyMutation$variables;
  response: verifyResetKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyResetKeyPayload",
    "kind": "LinkedField",
    "name": "verifyResetKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isKeyValid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyResetKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyResetKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b3d9a44619185529a53b5ccc5d12fca",
    "id": null,
    "metadata": {},
    "name": "verifyResetKeyMutation",
    "operationKind": "mutation",
    "text": "mutation verifyResetKeyMutation(\n  $input: VerifyResetKeyInput!\n) {\n  verifyResetKey(input: $input) {\n    isKeyValid\n  }\n}\n"
  }
};
})();

(node as any).hash = "a656de6bc13f7f0da631c86dcc7ff3db";

export default node;
